import {AdminAxios} from "../../common/Axios";

const isInit = false;
export async function findCreativeGroupList(value) {
  let returnVal = null;
  await AdminAxios('POST', `/adver/creative/list` ,{keyword: value})
    .then((response) => {
      const { data, statusCode } = response;
      if(statusCode ===200 ){
        returnVal = data;
      } else {
        returnVal = null;
      }
    }).catch((e) => returnVal = false)
  return returnVal;
};

export async function retrieveCreativeByUserId(userId) {
  let returnVal = null;
  await AdminAxios('GET', `/adver/creative/${userId}` ,null)
    .then((response) => {
      const { data, statusCode } = response;
      if(statusCode ===200 ){
        returnVal = data;
      } else {
        returnVal = null;
      }
    }).catch((e) => returnVal = false)
  return returnVal;
};